import React, {PureComponent} from "react";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import styles from "./app-store-panel.module.css";
import { IApplicationState } from "../../../store";
import { StoreVendor } from "../../../store/common/types";
import { trackAction } from "../../../store/common/actions";

interface AppStorePanelProps {
    readonly delay?: number;
    readonly appStoreUrl: string;
    readonly googlePlayUrl: string;
    readonly storeButtonClick: (storeVendor: StoreVendor) => void;
}

class AppStorePanel extends PureComponent<AppStorePanelProps> {
    render() {
        const {
            appStoreUrl,
            googlePlayUrl,
            storeButtonClick} = this.props;

        return (
            <div className={styles.app_store_panel}>
                <a href={appStoreUrl} target="_blank" className={styles.app_store_button} onClick={() => storeButtonClick('apple')}>Download on the App Store</a>
                <a href={googlePlayUrl} target="_blank" className={styles.google_play_button} onClick={() => storeButtonClick('google')}>Get it on Google play</a>
            </div>
        );
    }
}

export default connect(({ settings }: IApplicationState) => ({
    appStoreUrl: settings.urls.appStoreUrl,
    googlePlayUrl: settings.urls.googlePlayUrl
}), (dispatch: Dispatch) => ({
    storeButtonClick: (storeVendor: StoreVendor) => dispatch(trackAction({
        category: "game",
        object: storeVendor === 'apple'
            ? 'app-store'
            : storeVendor === 'huawei'
                ? 'app-gallery'
                : 'google-play',
        name: "click"
    }))
}))(AppStorePanel);